import { useTranslation } from 'react-i18next';

import { KebabMenu } from '~/components/KebabMenu';
import { useUser } from '~/modules/auth/hooks/useUser';

interface ListUserActionsProps {
  onEditClick: () => void;
}

export function ListUserActions({ onEditClick }: ListUserActionsProps) {
  const { hasPermission } = useUser();
  const { t } = useTranslation('settings', { keyPrefix: 'user' });

  const canEditUser = hasPermission('USER.EDIT');

  if (!canEditUser) {
    return null;
  }

  return (
    <KebabMenu>
      {canEditUser ? (
        <KebabMenu.Item
          onClick={(e) => {
            e.stopPropagation();
            onEditClick();
          }}
        >
          {t('list.editButton')}
        </KebabMenu.Item>
      ) : null}
    </KebabMenu>
  );
}

ListUserActions.displayName = 'ListUserActions';
